import {
  READ_ACTION,
  SUBSCRIPTIONS_STATISTICS,
  KPI,
  PEFORMANCE_EVOLUTION,
  CAMPAIGN_KPI,
  REALIZED_OKR,
  FUNNEL_FINANCIAL_PLNANNING,
} from '@/constants/resources'
import { infoFaturometro, infoKPI } from '@/helpers/modalInfo'

export default [
  {
    path: '/kpi',
    name: 'kpi-list',
    component: () => import('@/modules/kpi/views/KpiList.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      pageTitle: 'Faturômetro',
      info: infoKPI,
    },
  },
  {
    // A TELA DO MENU. A antiga continua respondendo em /kpi enquanto nao for
    // removida -- serve para conferir uma contra a outra e para quem tiver
    // link salvo -- mas o Faturometro que as pessoas abrem e este.
    //
    // A condicao anterior era "trocar o menu depois do comparador zerar em
    // staging". Caiu junto com a decisao de abandonar o KPI antigo: enquanto o
    // menu apontasse para la, toda regra nova nasceria na tela que vai sair --
    // foi o que aconteceu com o LTV/CL do card 1217381846456640.
    path: '/kpi/estrutura',
    name: 'kpi-tree',
    component: () => import('@/modules/kpi/views/KpiTreeView.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      // "por estrutura" so existia para distinguir das duas telas enquanto
      // conviviam no menu. O menu ja aponta so para esta.
      pageTitle: 'Faturômetro',
      info: infoFaturometro,
      infoTitle: 'Como ler o Faturômetro',
    },
  },
  {
    path: '/kpi/ranking-compromissos',
    name: 'kpi-ranking-appoiments',
    component: () => import('@/modules/kpi/views/RankingAppoiments.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      pageTitle: 'Ranking de compromissos',
    },
  },
  {
    path: '/kpi/ranking-invoicing',
    name: 'kpi-ranking-invoicing',
    component: () => import('@/modules/kpi/views/RankingInvoicing.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      pageTitle: 'Ranking de faturamento',
    },
  },
  {
    path: '/kpi/ranking-of-excellence',
    name: 'kpi-ranking-of-excellence',
    component: () => import('@/modules/kpi/views/RankingOfExcellence.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      pageTitle: 'Ranking de Excelência',
    },
  },
  {
    path: '/kpi/ranking-dna',
    name: 'kpi-ranking-dna',
    component: () => import('@/modules/kpi/views/RankingDnaChampion.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      pageTitle: 'Ranking DNA Campeão',
    },
  },
  {
    path: '/kpi/pnc-colaboracao',
    name: 'kpi-pnc-colaboracao',
    component: () => import('@/modules/kpi/views/RankingPncCollaboration.vue'),
    meta: {
      resource: KPI,
      action: READ_ACTION,
      pageTitle: 'PNC+ Colaboração',
    },
  },
  {
    path: '/kpi/lead-ao-planejamento',
    name: 'funnel-financial-planning',
    component: () => import('@/modules/kpi/views/FunnelFinancialPlanning.vue'),
    meta: {
      resource: FUNNEL_FINANCIAL_PLNANNING,
      action: READ_ACTION,
      pageTitle: 'KPI do Lead ao Plano Financeiro',
    },
  },
  {
    path: '/kpi/estatisticas-assinaturas',
    name: 'kpi-subscriptions-statistics',
    component: () => import('@/modules/kpi/views/SubscriptionStatistics.vue'),
    meta: {
      resource: SUBSCRIPTIONS_STATISTICS,
      action: READ_ACTION,
      pageTitle: 'Estatísticas de assinatura',
    },
  },
  {
    path: '/kpi/evolucao-performance',
    name: 'kpi-evolucao-performance',
    component: () => import('@/modules/kpi/views/PerformanceEvolution.vue'),
    meta: {
      resource: PEFORMANCE_EVOLUTION,
      action: READ_ACTION,
      pageTitle: 'Evolução de performance',
    },
  },
  {
    path: '/kpi/mapa-calor-dna',
    name: 'kpi-mapa-calor-dna',
    component: () => import('@/modules/kpi/views/DNAChampionHeatmap.vue'),
    meta: {
      resource: PEFORMANCE_EVOLUTION,
      action: READ_ACTION,
      pageTitle: 'Mapa de calor DNA Campeão',
    },
  },
  {
    path: '/kpi/campanhas',
    name: 'campanhas',
    component: () => import('@/modules/kpi/views/CampaignList.vue'),
    meta: {
      resource: CAMPAIGN_KPI,
      action: READ_ACTION,
      pageTitle: 'Campanhas',
    },
  },
  {
    path: '/okr',
    name: 'okr-dashboard',
    component: () => import('@/modules/okr/views/OkrDashboard.vue'),
    meta: {
      resource: REALIZED_OKR,
      action: READ_ACTION,
    },
  },
]
